import React, { FC } from 'react';
import classNames from 'classnames';
import { ProductThumbnailYesorNo } from '@root/app/react/uikit';
import { MozikokuinThumbnail } from '@component/thumbnail';
import {
    CARVING_WRITING_HORIZONTAL,
    CARVING_ATTENTION1,
    CARVING_ATTENTION2,
    CARVING_ATTENSION_DESCRIBE1,
    CARVING_ATTENSION_DESCRIBE2,
} from '@app/react/const/variables';
import { PartsProduct } from '@app/react/const/type';

const getName = (product: PartsProduct) => {
    const p = product?.price?.toLocaleString();
    if (p === undefined) {
        return '---';
    }
    return p;
};

interface IMozikokuinBodyDesktopComponentProps {
    status: boolean;
    toggleStatus: (v: boolean) => void;
    viewData: Array<PartsProduct>;
    selectedProduct: PartsProduct | null;
    onSelectProduct: (product: PartsProduct) => void;
    carvingString: string | null;
    onChangeText: React.ChangeEventHandler<HTMLInputElement>;
    noProduct: PartsProduct;
    yesProduct: PartsProduct;
}

export const MozikokuinBodyDesktopComponent: FC<IMozikokuinBodyDesktopComponentProps> = (props) => {
    const {
        status,
        toggleStatus,
        viewData,
        selectedProduct,
        onSelectProduct,
        carvingString,
        onChangeText,
        noProduct,
        yesProduct,
    } = props;

    const msd = {
        'mojikokuin-select-disable': !status,
    };

    const isH = selectedProduct?.options?.carvingWritingType === CARVING_WRITING_HORIZONTAL;

    return (
        <div className="order-mozikokuin">
            <div className="order-mozikokuin__body">
                <div className="order-mozikokuin-select-div">
                    <p className="tab-string-label-title">①文字刻印の有無</p>
                    <div className="tab-string-content">
                        <label
                            htmlFor="TAB-COLOR-02"
                            className="tab-string-label"
                        >
                            <input
                                id="TAB-COLOR-02"
                                type="radio"
                                name="TAB"
                                className="tab-color-switch"
                            />
                            <ProductThumbnailYesorNo
                                name={`${noProduct.name}（+¥${noProduct.price.toLocaleString()}/本）`}
                                clicked={!status}
                                imgSrc={noProduct.productImages[0]}
                                onChange={() => toggleStatus(false)}
                                groupName="mozikokuin"
                            />
                        </label>
                        <label
                            htmlFor="TAB-COLOR-01"
                            className="tab-string-label"
                        >
                            <input
                                id="TAB-COLOR-01"
                                type="radio"
                                name="TAB"
                                className="tab-color-switch"
                            />
                            <ProductThumbnailYesorNo
                                name={`${yesProduct.name}（+¥${getName(yesProduct)}/本）`}
                                clicked={status}
                                imgSrc={yesProduct.productImages[0]}
                                onChange={() => toggleStatus(true)}
                                groupName="mozikokuin"
                            />
                        </label>
                    </div>

                    <p className={classNames('tab-string-label-title', msd)}>
                        ②書体
                    </p>
                    <p className={classNames('tab-string-comment', msd)}>
                        ※書体のイメージは実際の仕上がりと異なる場合がございます。
                        具体的なフォントの指定は出来兼ねますので予めご了承ください。
                    </p>
                    <div className={classNames('tab-string-content', msd)}>
                        {viewData.map((product) => {
                            const selected = product.id === selectedProduct?.id;
                            return (
                                <MozikokuinThumbnail
                                    key={product.id}
                                    product={product}
                                    selected={selected}
                                    onClick={onSelectProduct}
                                    disabled={!status}
                                />
                            );
                        })}
                    </div>

                    <p className={classNames('tab-string-label-title', msd)}>
                        ③刻印文字
                    </p>
                    <div className={classNames('product-container-text-input', msd)}>
                        <span className="attension-describe">
                            {isH ? CARVING_ATTENSION_DESCRIBE2 : CARVING_ATTENSION_DESCRIBE1}
                        </span>
                        <input
                            type="text"
                            className="mozikokuin-input-text"
                            placeholder="刻印文字を入力してください"
                            value={carvingString || ''}
                            onChange={onChangeText}
                        />
                        <div className="text-input-label-div">
                            <p className="text-input-label-p1">
                                {selectedProduct?.name}
                            </p>
                            <p className="text-input-label-p2">
                                {isH ? CARVING_ATTENTION2 : CARVING_ATTENTION1}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
